export const TRANSPARENT_NAVBAR_THRESHOLD = 1
